import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["nextLink", "subject", "body", "aiToggle", "aiForm"]

  static values = { started: Boolean, saving: Boolean }

  connect() {
    if (this.hasNextLinkTarget) {
      this.toggle()
    }
  }

  // Every time the content of the follow ups changes, we see if it is necessary
  // to change the button.
  toggle() {
    // If the campaign has already been started or if we are currently saving a follow up this controller is deactived.
    if (this.startedValue || this.savingValue) {
      return
    }

    // If the button is not on the screen this controller won't do anything
    if (!this.hasNextLinkTarget) {
      return
    }

    let disabled = false

    this.subjectTargets.forEach(function (target) {
      // A value is required only for the subject of the first message, follow-ups subject
      // lines can be empty
      if ((target.dataset.step == "0" && target.value == "") || target.value.indexOf(':"FALLBACK"') != -1) {
        disabled = true
        return
      }
    })

    this.bodyTargets.forEach(function (target) {
      if (target.value == "" || target.value.indexOf(':"FALLBACK"') != -1) {
        disabled = true
        return
      }
    })

    if (this.hasAiToggleTarget && this.aiToggleTarget.checked && !this.aiFormTarget.checkValidity()) {
      disabled = true
    }

    if (disabled) {
      this._disableNextLink()
      return
    }

    this._enableNextLink()
  }

  saving() {
    if (!this.hasNextLinkTarget) {
      return
    }

    this.savingValue = true
    this._disableNextLink()
  }

  finishedSaving() {
    if (!this.hasNextLinkTarget) {
      return
    }

    this.savingValue = false
    this._enableNextLink()
    this.toggle()
  }

  _enableNextLink() {
    this.nextLinkTarget.classList.remove("disabled")
    this.nextLinkTarget.setAttribute("href", $(this.nextLinkTarget).data("destination"))
  }

  _disableNextLink() {
    this.nextLinkTarget.classList.add("disabled")
    this.nextLinkTarget.removeAttribute("href")
  }
}
